import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Avatar, Box, Button, Divider, Fab, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { addImagesLink, deleteLink, updateImagesLink } from '../../services/material-services';
import { CssTextField } from '../layout/elements';
import { NotificationManager } from 'react-notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ProgressWait from '../layout/progress';
import HomeIcon from '@mui/icons-material/Home';


const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}));


function MaterialMakeLink() {
    
    const { authData, authDataGroup } = useAuth();
    const [isAdmin, setIsAdmin] = useState(false);
    const [statusReq, setStatusReq ] = useState(false);
    const [loading, setLoading ] = useState(false);

    const location = useLocation();
    const { state } = location;

    const [remarks, setRemarks ] = useState('');
    const [titleRep, setTitleRep ] = useState('');
    const [matLink, setMatLink ] = useState('');
    const [imageLink, setImageLink ] = useState('');
    const [matID, setMatID ] = useState(0);
    const [linkID, setLinkID ] = useState(0);
    const [matBuyID, setMatBuyID ] = useState(0);
    const [matHashTag, setMatHashTag ] = useState('');
    const cssClass = useStyles();
    // const navigate = useNavigate();
    
    
    useEffect(() => {
        window.scrollTo(0, 0);
        if(authData?.user){
            setIsAdmin(authData?.user?.profile?.is_permium);
        }
        setImageLink(state?.link_images);
        setMatHashTag(state?.hash_tag);
        // console.log(state);
        // if (state != null){
            // setStatusReq(true);
            if (state?.link_images?.id){
                setLinkID(state?.link_images?.id);
            }
            if (state.id){
                setMatID(state.id);
            }
            setMatBuyID(state.matbuy_id);
            // if (state?.link_images?.link_title){
            //     setTitleRep(state?.link_images?.link_title);
            // }
            // if (state?.link_images?.demo_link){
            //     setMatLink(state?.link_images?.demo_link);
            // }
            // if (state?.link_images?.link_description){
            //     setRemarks(state?.link_images?.link_description);
            // }
            
        // }
    }, [state]);

    const viewLinks = (id) => {
        // console.log(materials.material.group);
        // console.log( id);
        setLinkID(id.id);
        setTitleRep(id.link_title);
        setMatLink(id.demo_link);
        setRemarks(id.link_description);
        setStatusReq(true);
    }

    const newLinks = (id) => {
        // console.log(materials.material.group);
        // console.log( id);
        setLinkID(0);
        setTitleRep('');
        setMatLink('');
        setRemarks('');
        setStatusReq(false);
    }

    const handelSubmitImage = async e => {
        e.preventDefault();
        setLoading(true);
        
        if(statusReq){
            const addNewMaterial = await updateImagesLink(authData?.token, linkID, 
                {'image_list':matID, 'link_title':titleRep, 'demo_link':matLink, 'link_description':remarks});
            // console.log(addNewMaterial);
            if (addNewMaterial){
                NotificationManager.success('لینک بروزرسانی شد');
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان بروزرسانی لینک وجود دارد');
            }
        }else{
            const addNewMaterial = await addImagesLink(authData?.token, 
                {'image_list':matID, 'link_title':titleRep, 'demo_link':matLink, 'link_description':remarks});
            // console.log(addNewMaterial);
            if (addNewMaterial){
                NotificationManager.success('لینک جدید به برنامه اضافه شد');
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت لینک وجود دارد');
            }
        }
        setLoading(false);
    }
    
    const submitDelete = async e =>{
        setLoading(true);
        const delMaterial = await deleteLink(authData?.token, {'link_id' : linkID});
        if (delMaterial){
            NotificationManager.success('لینک با موفقیت حذف شد');
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان حذف لینک وجود دارد');
        }
        setLoading(false);
    }
        
    if (loading) return <ProgressWait statusWait={true}/> 
    if (!isAdmin) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
    <div style={{minHeight: 1000}}>
        <Link to={`/material-detail/${authDataGroup?.name}/${matBuyID}/#${matHashTag}`}>
            <Avatar >
                <HomeIcon color='primary' sx={{ fontSize: 40}}/>
            </Avatar>  
        </Link>

        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            
            <Typography
                fontFamily='b_mitra' 
                component="div"
                variant="h4"
                >
                لینک سازی({state?.name})
            </Typography>
            {isAdmin && statusReq &&
                <Fab variant="extended" 
                    size="small" color="secondary" 
                    aria-label="add" 
                    sx={{
                        textAlign: 'right',
                        fontFamily: 'b_mitra'
                    }}
                    onClick={submitDelete}
                    >
                    <DeleteIcon sx={{ mr: 1 }} />
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h5"
                        >
                        حذف
                    </Typography>
                </Fab>
            }
        </div>        
        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
              }}
            >
            <Paper elevation={3} sx={{
                display: 'block',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right',
                }} >

                <form onSubmit={handelSubmitImage}>
                    <div style={{textAlign: 'right', marginRight: 20}}>

                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-replace-text" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            متن جایگزینی
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard" value={titleRep}
                                    onChange={ e => setTitleRep( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <AttachFileIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-links" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            لینک
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard"  value={matLink}
                                    onChange={ e => setMatLink( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item >
                                <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-remarks" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            توضیحات
                                        </Typography>
                                    )}
                                    multiline
                                    fullWidth
                                    rows={4} 
                                    className={cssClass.header_dtl}
                                    variant="standard" value={remarks}
                                    onChange={ e => setRemarks( e.target.value )} />
                            </Grid>
                        </Grid>
                    </div>
                    <br />
                    <Divider />
                    <br/>
                                
                    <Button sx={{fontFamily: 'b_mitra', paddingLeft: 5, paddingRight: 5, margin: 5}} 
                        variant="contained" color="primary" type='submit'
                        disabled={!titleRep || !matLink}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h4"
                            >
                            ثبت
                        </Typography>
                    </Button>
                </form>
            </Paper>
        </Box>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
              }}
            >
            {imageLink && imageLink.map(imgLink => {
                return <div key={imgLink.id}>
                    <Grid container spacing={1} alignItems='flex-end'>
                        <Grid item xs>
                             
                            <Button 
                                sx={{fontFamily: 'b_mitra'}}
                                variant="contained" color="primary" type='submit'
                                onClick={e => viewLinks(imgLink)} 
                                >
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    >
                                    {imgLink.link_title}
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            })}
            <br/><hr/>
            <Button 
                variant="contained" color="primary" type='submit'
                onClick={newLinks} 
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    >
                    جدید
                </Typography>
            </Button>
        </Box>
    </div>
    </React.Fragment>
  );
}

export default MaterialMakeLink;
